import React from 'react';
import styled from 'styled-components';

import { Col } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

const Column = styled(Col)`
  margin-bottom: ${({ mBottom }) => mBottom}px;
`;

const ReferralTrackedProgressEvents = ({ trackedProgressEvents }) => {
  return (
    <>
      {trackedProgressEvents?.map((el, i) => {
        return (
          <Column mBottom={24} gutter={0} key={i}>
            {Object.entries(el)?.map(([key, value], k) => {
              return (
                <Column mBottom={4} key={`${key}-${value}`}>
                  <Text variant="eyebrow2">{key}</Text>
                  <Text variant="h6">{value}</Text>
                </Column>
              );
            })}
          </Column>
        );
      })}
    </>
  );
};

export default ReferralTrackedProgressEvents;
